export default __webpack_public_path__ + "static/media/AppraisalWF4.8f4e8894.png";